<template>
  <div
    class="bulk-discount"
  >
    <img
      class="bulk-discount__image"
      src="@/assets/offer/discount.svg"
      alt=""
    >
    <p class="bulk-discount__title">
      Bulk discount? &nbsp;
      <span
        class="bulk-discount__button"
        @click="showNewMessage()"
      >
        Apply Discount
      </span>
    </p>
  </div>
</template>

<script setup>
import { useIntercom } from '@/hooks/useIntercom'

const { showNewMessage } = useIntercom()
</script>

<style lang="less" scoped>
.bulk-discount {
  display: flex;
  align-items: center;
  gap: 2px;

  &__image {
    width: 24px;
    height: 24px;
  }

  &__title {
    font-family: mon-500;
    font-size: 12px;
    line-height: 16px;
    color: #232323;
  }

  &__button {
    text-decoration: underline;
    color: #007EB3;
    cursor: pointer;
  }
}
</style>
